export const ru = {
    MB: 'МБ',
    'action-text': 'Выберите файл',
    'button-title-copy': 'Скопировать код для вставки',
    'button-title-delete': 'Удалить',
    'button-title-download': 'Скачать',
    confirm: 'Вы действительно хотите удалить файл?',
    'drop-text': 'для загрузки на страницу',
    'error-delete-title': 'Не удалось удалить файл',
    'error-empty-description': 'На этой странице пока нет файлов.',
    'error-empty-title': 'Здесь ничего нет',
    'error-get-description': 'Попробуйте снова',
    'error-get-title': 'Не удалось загрузить список файлов',
    'error-message-limit': 'Попробуйте позже',
    'error-message-size-limit': 'Превышен допустимый размер файла',
    'error-message-validation': 'В имени файла присутствуют недопустимые символы',
    'error-upload-text': 'Не удалось загрузить файл',
    title: 'Файлы'
};
